// Lieux hors plan et classement : valeurs non arrondies pour les totaux et le tri.
export function groupOffStops(stops = []) {
  const groups = new Map();
  for (const stop of stops) {
    const name = stop.place?.name?.trim();
    const position = `${stop.lat.toFixed(4)}, ${stop.lon.toFixed(4)}`;
    const key = name ? `${stop.place.source || "place"}:${name.toLocaleLowerCase("fr")}` : `gps:${position}`;
    if (!groups.has(key)) groups.set(key, { key, name: name || "Lieu non identifié", position: name ? null : position, minutes: 0, visits: [] });
    const group = groups.get(key);
    group.minutes += stop.minutes;
    group.visits.push(stop);
  }
  return [...groups.values()].sort((a, b) => b.minutes - a.minutes || a.name.localeCompare(b.name, "fr")).map(group => ({
    ...group, visits: group.visits.sort((a, b) => b.date.localeCompare(a.date) || b.arrival - a.arrival),
  }));
}
